import { reduxKey, SimpleXHREndpoint } from './constants';
function getStateSlice(state) {
    return state[reduxKey];
}
export const getIsLoading = (state, endpoint)=>getStateSlice(state).loadingEndpoints.includes(endpoint);
export const getIsLoadingForGivePointsXHR = (state)=>getIsLoading(state, SimpleXHREndpoint.GIVE_POINTS);
export const getIsLoadingForGiveLlamaXHR = (state)=>getIsLoading(state, SimpleXHREndpoint.GIVE_LLAMA);
export const getInitGivePointsPopupXHRCallResult = (state)=>getStateSlice(state)['results'][SimpleXHREndpoint.GIVE_POINTS_POPUP];
export const getGiveLlamaXHRCallResult = (state)=>getStateSlice(state)['results'][SimpleXHREndpoint.GIVE_LLAMA];
